<template lang="pug">
yz-filter-menu(:label="$t('panel.mc_days')" :is-active="isActive" :display-value="displayValue" :disable-apply="!isValid" @clear="onClear" @apply="onApply")
  .pa-4
    yz-dropdown.mb-3(:items="comparisonOptions" item-text="label" item-value="value" v-model="selectedComparison" :label="$t('panel.comparison')" size="lg")

    template(v-if="selectedComparison === 'between'")
      .d-flex.align-center.gap-2
        yz-icon(size=16) $yzi-corner-down-right
        yz-text-field(v-model.number="minValue" :label="$t('panel.minimum_days')" type="number" size="lg" min="0" :rules="daysRules")
        div {{ $t('to') }}
        yz-text-field(v-model.number="maxValue" :label="$t('panel.maximum_days')" type="number" size="lg" min="0" :rules="daysRules")
    template(v-else)
      .d-flex.align-center.gap-2
        yz-icon(size=16) $yzi-corner-down-right
        yz-text-field(v-model.number="singleValue" type="number" size="lg" min="0" :rules="daysRules" width="100%" placeholder="Enter number of days")
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedComparison: 'exact',
      singleValue: null,
      minValue: null,
      maxValue: null,
      isActive: false,
      displayValue: ''
    }
  },
  computed: {
    comparisonOptions() {
      return [
        { label: this.$t('panel.is'), value: 'exact' },
        { label: this.$t('panel.is_not'), value: 'ne' },
        { label: this.$t('panel.less_than'), value: 'lt' },
        { label: this.$t('panel.more_than'), value: 'gt' },
        { label: this.$t('panel.is_between'), value: 'between' }
      ]
    },
    daysRules() {
      return [
        v => v === null || v === '' || v >= 0 || this.$t('days_cannot_be_negative'),
        v => v === null || v === '' || Number.isInteger(Number(v)) || this.$t('days_must_be_integer')
      ]
    },
    isValid() {
      if (this.selectedComparison === 'between') {
        const minValid = this.minValue !== null && this.minValue >= 0 &&
                        this.daysRules.every(rule => rule(this.minValue) === true)
        const maxValid = this.maxValue !== null && this.maxValue >= 0 &&
                        this.daysRules.every(rule => rule(this.maxValue) === true)
        return minValid && maxValid && this.minValue <= this.maxValue
      }
      return this.singleValue !== null && this.singleValue >= 0 &&
             this.daysRules.every(rule => rule(this.singleValue) === true)
    }
  },
  methods: {
    onClear() {
      this.singleValue = null
      this.minValue = null
      this.maxValue = null
      this.selectedComparison = 'exact'
      this.isActive = false
      this.displayValue = ''
      this.$emit('update:filter', {})
    },
    onApply() {
      this.isActive = true

      let filterData = {}
      const comparisonLabel = this.comparisonOptions.find(o => o.value === this.selectedComparison)?.label || ''

      if (this.selectedComparison === 'between') {
        const dayLabel = value => value === 1 ? this.$t('day') : this.$t('panel.days')
        this.displayValue = `${comparisonLabel} ${this.minValue} ${dayLabel(this.minValue)} - ${this.maxValue} ${dayLabel(this.maxValue)}`
        filterData = {
          key: 'mc_days__range',
          value: [this.minValue, this.maxValue],
          params: {
            mc_days__gt: this.minValue,
            mc_days__lt: this.maxValue
          }
        }
      } else {
        const suffixMap = {
          gt: '__gt',
          lt: '__lt',
          ne: '__ne',
          exact: ''
        }
        const key = `mc_days${suffixMap[this.selectedComparison]}`
        const dayLabel = this.singleValue === 1 ? this.$t('day').toLowerCase() : this.$t('panel.days').toLowerCase()

        this.displayValue = `${comparisonLabel} ${this.singleValue} ${dayLabel}`
        filterData = {
          key,
          value: this.singleValue
        }
      }

      this.$emit('update:filter', filterData)
    },
    reset() {
      this.onClear()
    },
    restoreFromParams(params) {
      // Restore filter state from URL params
      if (params.mc_days !== undefined) {
        this.selectedComparison = 'exact'
        this.singleValue = params.mc_days
      } else if (params.mc_days__gt !== undefined) {
        this.selectedComparison = 'gt'
        this.singleValue = params.mc_days__gt
      } else if (params.mc_days__lt !== undefined) {
        this.selectedComparison = 'lt'
        this.singleValue = params.mc_days__lt
      } else if (params.mc_days__ne !== undefined) {
        this.selectedComparison = 'ne'
        this.singleValue = params.mc_days__ne
      } else if (params.mc_days__gt !== undefined && params.mc_days__lt !== undefined) {
        this.selectedComparison = 'between'
        this.minValue = params.mc_days__gt
        this.maxValue = params.mc_days__lt
      }

      // Apply to set isActive and displayValue
      if (this.isValid) {
        this.onApply()
      }
    }
  }
}
</script>
